import React, { Component } from 'react';
import {Card, CardBody, CardTitle, CardHeader, CardBlock} from "reactstrap";



class Loader extends Component {
render() {
        return (        
          <Card>                  
            <CardBody className="card-body">
              <div className="sk-cube-grid">
                <div className="sk-cube sk-cube1"></div>
                <div className="sk-cube sk-cube2"></div>
                <div className="sk-cube sk-cube3"></div>
                <div className="sk-cube sk-cube4"></div>
                <div className="sk-cube sk-cube5"></div>
                <div className="sk-cube sk-cube6"></div>
                <div className="sk-cube sk-cube7"></div>
                <div className="sk-cube sk-cube8"></div>
                <div className="sk-cube sk-cube9"></div>
              </div>
            </CardBody>
          </Card>
        )
    }
}
export default Loader


// WEBPACK FOOTER //
// ./src/components/Loader/index.js